import { useCallback, useRef } from 'react';

/**
 * ダイアログの状態管理を行うカスタムフック
 * @returns ダイアログの状態、ref、および制御関数
 */
export const useDialog = () => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  const open = useCallback(() => {
    dialogRef.current?.showModal();
  }, []);

  const close = useCallback(() => {
    dialogRef.current?.close();
  }, []);

  const isOpen = useCallback(() => dialogRef.current?.open ?? false, []);

  return {
    isOpen,
    dialogRef,
    open,
    close,
  };
};
